var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 439.029,
    height: 310.181,
    viewBox: "0 0 439.029 310.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.982,
    y1: 0.015,
    x2: 0.015,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eaeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#4583ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#427bdd",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759fe6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_459",
    x: 15.731,
    y: 230.843,
    width: 44.497,
    height: 56.505,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_460",
    x: 33.728,
    y: 248.421,
    width: 43.743,
    height: 44.922,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_463",
    x: 10.472,
    y: 258.352,
    width: 50.3,
    height: 41.738,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_501",
    x: 315.356,
    y: 61.73,
    width: 91.465,
    height: 87.135,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_502",
    x: 356.765,
    y: 77.828,
    width: 50.546,
    height: 45.799,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.982,
    y1: 0.015,
    x2: 0.015,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315fad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#4583ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#133f8b",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11336e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_539",
    x: 98.981,
    y: 113.699,
    width: 259.52,
    height: 195.858,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_540",
    x: 33.596,
    y: 87.945,
    width: 285.818,
    height: 222.235,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_543",
    x: 283.455,
    y: 3.902,
    width: 44.844,
    height: 50.756,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_544",
    x: 288.935,
    y: 25.835,
    width: 33.311,
    height: 33.314,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2850",
    "data-name": "Group 2850",
    transform: "translate(-409.853 -332.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2849",
    "data-name": "Group 2849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(409.853 289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619",
    transform: "translate(0 92.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2603",
    "data-name": "Group 2603"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 102.144,
    height: 150.403,
    transform: "matrix(0.831, -0.556, 0.556, 0.831, 0, 56.788)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2606",
    "data-name": "Group 2606",
    transform: "translate(81.489 97.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2604",
    "data-name": "Group 2604",
    transform: "translate(0 15.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M258.538,277.7l-.964,5.963-42.206-6.08.964-5.963Z",
    transform: "translate(-215.368 -271.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    transform: "translate(15.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M242.17,251.546l6.056.873-6.715,41.555-6.057-.872Z",
    transform: "translate(-235.454 -251.546)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2608",
    "data-name": "Group 2608",
    transform: "translate(91.4 47.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2607",
    "data-name": "Group 2607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M228.466,184.995",
    transform: "translate(-228.466 -184.995)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2610",
    "data-name": "Group 2610",
    transform: "translate(26.303 44.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2609",
    "data-name": "Group 2609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M180.66,181.745c.061.091-8.448,5.888-19,12.947S142.5,207.4,142.436,207.311s8.446-5.886,19-12.947S180.6,181.655,180.66,181.745Z",
    transform: "translate(-142.436 -181.744)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2612",
    "data-name": "Group 2612",
    transform: "translate(32.332 37.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M213.822,171.387c.061.091-14.089,9.66-31.6,21.372S150.463,213.9,150.4,213.8s14.086-9.657,31.6-21.374S213.762,171.3,213.822,171.387Z",
    transform: "translate(-150.403 -171.386)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(38.591 46.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M222.093,183.753c.061.091-14.089,9.66-31.6,21.372s-31.76,21.136-31.82,21.046,14.086-9.658,31.6-21.374S222.033,183.663,222.093,183.753Z",
    transform: "translate(-158.675 -183.752)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(44.849 55.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M230.364,196.12c.061.09-14.088,9.66-31.6,21.372s-31.76,21.137-31.82,21.046,14.086-9.658,31.6-21.374S230.3,196.029,230.364,196.12Z",
    transform: "translate(-166.946 -196.119)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(51.108 65.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M238.636,208.486c.061.091-14.089,9.66-31.6,21.372s-31.76,21.137-31.82,21.046,14.086-9.657,31.6-21.373S238.576,208.4,238.636,208.486Z",
    transform: "translate(-175.217 -208.485)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2636",
    "data-name": "Group 2636",
    transform: "translate(297.5 176.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2620",
    "data-name": "Group 2620"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 85.784,
    height: 126.313,
    transform: "translate(0 47.692) rotate(-33.777)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623",
    transform: "translate(68.437 82.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2621",
    "data-name": "Group 2621",
    transform: "translate(0 12.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M627.541,363.537l-.809,5.008-35.446-5.106.809-5.008Z",
    transform: "translate(-591.285 -358.431)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2622",
    "data-name": "Group 2622",
    transform: "translate(12.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M613.794,341.569l5.086.733-5.639,34.9-5.086-.733Z",
    transform: "translate(-608.155 -341.569)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(76.76 39.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M602.285,285.678",
    transform: "translate(-602.285 -285.678)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627",
    transform: "translate(22.09 37.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M562.137,282.948c.061.091-7.077,4.971-15.941,10.9s-16.1,10.663-16.161,10.572,7.076-4.969,15.942-10.9S562.076,282.858,562.137,282.948Z",
    transform: "translate(-530.034 -282.946)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629",
    transform: "translate(27.153 31.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M589.987,274.249c.061.091-11.814,8.14-26.519,17.975s-26.681,17.74-26.742,17.649,11.812-8.137,26.522-17.977S589.926,274.159,589.987,274.249Z",
    transform: "translate(-536.726 -274.248)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2631",
    "data-name": "Group 2631",
    transform: "translate(32.41 39.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2630",
    "data-name": "Group 2630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M596.934,284.635c.061.09-11.815,8.139-26.52,17.975s-26.68,17.739-26.741,17.649,11.812-8.137,26.522-17.976S596.873,284.544,596.934,284.635Z",
    transform: "translate(-543.673 -284.634)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2633",
    "data-name": "Group 2633",
    transform: "translate(37.666 46.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2632",
    "data-name": "Group 2632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M603.88,295.02c.06.091-11.814,8.14-26.519,17.975s-26.681,17.74-26.742,17.649,11.812-8.137,26.522-17.976S603.819,294.93,603.88,295.02Z",
    transform: "translate(-550.619 -295.019)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635",
    transform: "translate(42.922 54.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    "data-name": "Group 2634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M610.827,305.406c.061.091-11.815,8.139-26.52,17.975s-26.68,17.739-26.741,17.649,11.812-8.137,26.522-17.976S610.766,305.316,610.827,305.406Z",
    transform: "translate(-557.566 -305.405)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    transform: "translate(116.93 55.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2637",
    "data-name": "Group 2637"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 88.228,
    height: 129.913,
    transform: "matrix(0.882, 0.472, -0.472, 0.882, 61.268, 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2640",
    "data-name": "Group 2640",
    transform: "translate(37.652 85.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2638",
    "data-name": "Group 2638",
    transform: "translate(9.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M341.806,221.23l-4.936,1.69-12.529-34.636,4.936-1.69Z",
    transform: "translate(-324.341 -186.594)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2639",
    "data-name": "Group 2639",
    transform: "translate(0 9.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M346.362,199.529l1.8,4.97-34.4,11.781-1.8-4.97Z",
    transform: "translate(-311.964 -199.529)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2642",
    "data-name": "Group 2642",
    transform: "translate(105.544 65.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2641",
    "data-name": "Group 2641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M401.689,160.379",
    transform: "translate(-401.689 -160.379)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2644",
    "data-name": "Group 2644",
    transform: "translate(61.464 25.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2643",
    "data-name": "Group 2643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M378.46,125.968c-.06.114-7.952-3.987-17.622-9.16s-17.465-9.459-17.4-9.573,7.95,3.987,17.625,9.16S378.522,125.855,378.46,125.968Z",
    transform: "translate(-343.434 -107.234)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2646",
    "data-name": "Group 2646",
    transform: "translate(57.047 33.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2645",
    "data-name": "Group 2645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M395.71,149.232c-.061.113-13.12-6.752-29.165-15.333s-29.009-15.633-28.947-15.746,13.117,6.75,29.168,15.334S395.771,149.118,395.71,149.232Z",
    transform: "translate(-337.597 -118.151)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2648",
    "data-name": "Group 2648",
    transform: "translate(52.461 42.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2647",
    "data-name": "Group 2647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M389.649,160.564c-.061.113-13.121-6.752-29.166-15.333s-29.008-15.633-28.947-15.747,13.118,6.75,29.168,15.335S389.71,160.45,389.649,160.564Z",
    transform: "translate(-331.536 -129.482)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2650",
    "data-name": "Group 2650",
    transform: "translate(47.875 51.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2649",
    "data-name": "Group 2649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M383.589,171.9c-.06.114-13.12-6.752-29.165-15.333s-29.009-15.633-28.947-15.747,13.117,6.75,29.168,15.335S383.65,171.782,383.589,171.9Z",
    transform: "translate(-325.476 -140.814)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    transform: "translate(43.289 59.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2651",
    "data-name": "Group 2651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M377.528,183.227c-.061.114-13.121-6.752-29.165-15.333s-29.009-15.633-28.948-15.747,13.118,6.75,29.168,15.335S377.589,183.114,377.528,183.227Z",
    transform: "translate(-319.415 -152.146)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(435.853 574.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2668",
    "data-name": "Group 2668",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659",
    transform: "translate(5.232)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -31.23, -241.43)",
    filter: "url(#Path_459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459-2",
    "data-name": "Path 459",
    d: "M117.386,377.2a9.538,9.538,0,0,1,6.647,3.4,16.839,16.839,0,0,1,3.384,6.818c1.28,4.785.493,10.432-.872,15.193-5.179-1.852-8.374-7.376-9.819-10.28-2.283-4.59-3.621-14.272.659-15.136",
    transform: "translate(-83.36 -135.77)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660",
    transform: "translate(23.35 17.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -49.35, -258.93)",
    filter: "url(#Path_460)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460-2",
    "data-name": "Path 460",
    d: "M139.826,414.042a8.138,8.138,0,0,1-.381-8.161,10.81,10.81,0,0,1,6.508-5.231,4.552,4.552,0,0,1,3.83.183,3.482,3.482,0,0,1,1.339,3.263,7.051,7.051,0,0,1-1.49,3.348c-2.518,3.41-5.582,6.248-9.807,6.6",
    transform: "translate(-89.18 -141.39)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2662",
    "data-name": "Group 2662",
    transform: "translate(23.706 23.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2661",
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M140.51,431.889a5.715,5.715,0,0,1-.232-.994l-.533-2.727a28.559,28.559,0,0,1-.567-9.159,17.481,17.481,0,0,1,3.4-8.488,11.909,11.909,0,0,1,1.965-1.986,7.3,7.3,0,0,1,.617-.443c.145-.1.224-.14.231-.13a18.662,18.662,0,0,0-2.611,2.713,18.051,18.051,0,0,0-3.243,8.382,30.752,30.752,0,0,0,.461,9.066c.185,1.158.335,2.1.421,2.747A5.391,5.391,0,0,1,140.51,431.889Z",
    transform: "translate(-139.003 -407.961)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2664",
    "data-name": "Group 2664",
    transform: "translate(9.699 7.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2663",
    "data-name": "Group 2663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M120.493,386.826a2.09,2.09,0,0,1,.208.393l.534,1.153c.458,1,1.1,2.465,1.881,4.278,1.56,3.624,3.646,8.66,5.824,14.273s4.032,10.742,5.323,14.471c.645,1.864,1.155,3.376,1.494,4.427.157.5.284.9.383,1.211a2.014,2.014,0,0,1,.11.431,2.123,2.123,0,0,1-.179-.407l-.447-1.189-1.6-4.388c-1.351-3.705-3.243-8.815-5.419-14.426s-4.224-10.658-5.723-14.3l-1.776-4.321c-.193-.484-.35-.875-.471-1.18A2.056,2.056,0,0,1,120.493,386.826Z",
    transform: "translate(-120.492 -386.826)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2665",
    "data-name": "Group 2665",
    transform: "translate(0 27.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -26, -268.86)",
    filter: "url(#Path_463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463-2",
    "data-name": "Path 463",
    d: "M126.739,422.645a19.032,19.032,0,0,0-14.772-9.178c-1.531-.111-3.373.146-4.056,1.521s.231,3.008,1.273,4.138a16.263,16.263,0,0,0,17.611,3.931",
    transform: "translate(-81.67 -144.59)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2667",
    "data-name": "Group 2667",
    transform: "translate(6.624 31.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2666",
    "data-name": "Group 2666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M116.429,418.888a4.968,4.968,0,0,1,.959.036,9.278,9.278,0,0,1,1.118.129c.431.081.934.128,1.468.276a16.842,16.842,0,0,1,1.745.485,18.917,18.917,0,0,1,1.946.739,21.2,21.2,0,0,1,4.1,2.43,20.747,20.747,0,0,1,3.388,3.353,18.108,18.108,0,0,1,1.193,1.706,15.221,15.221,0,0,1,.888,1.58,14.082,14.082,0,0,1,.61,1.364,8.582,8.582,0,0,1,.381,1.06,4.974,4.974,0,0,1,.25.926c-.076.027-.445-1.3-1.465-3.233a16.624,16.624,0,0,0-.913-1.536,19.179,19.179,0,0,0-1.2-1.66,21.522,21.522,0,0,0-3.35-3.275,22,22,0,0,0-4.016-2.413,19.738,19.738,0,0,0-1.9-.759,17.827,17.827,0,0,0-1.711-.521C117.789,419.04,116.421,418.966,116.429,418.888Z",
    transform: "translate(-116.429 -418.876)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(699.369 340.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2834",
    "data-name": "Group 2834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2672",
    "data-name": "Group 2672",
    transform: "translate(49.25 26.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2669",
    "data-name": "Group 2669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M566.715,104.97c-2.225.512-3.308,3.072-3.519,5.346s.079,4.674-.876,6.748c-1.074,2.334-3.641,4.055-3.727,6.623-.052,1.566.878,3.039.833,4.6-.073,2.573-2.7,4.516-2.834,7.085-.1,1.85,1.133,3.626.837,5.455-.231,1.423-1.339,2.545-1.807,3.908-.935,2.719.933,5.711,3.366,7.242a11.034,11.034,0,0,0,16.077-5.137c1.346-3.268,1.052-6.948.76-10.469q-1.368-16.465-2.032-32.977",
    transform: "translate(-555.378 -103.399)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2671",
    "data-name": "Group 2671",
    transform: "translate(4.875 2.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2670",
    "data-name": "Group 2670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M561.823,144.488a2.668,2.668,0,0,0,1.017-1.209,4.291,4.291,0,0,0,.259-1.847,10.233,10.233,0,0,0-.552-2.45,6.992,6.992,0,0,1-.4-3.1,7.076,7.076,0,0,1,1.8-3.1,6.9,6.9,0,0,0,1.021-1.553,2.508,2.508,0,0,0,.119-1.814c-.391-1.236-1.6-2.146-2.158-3.572a3.856,3.856,0,0,1-.122-2.208,8.967,8.967,0,0,1,.73-1.981,16.947,16.947,0,0,0,1.5-3.56c.531-2.4.283-4.691.645-6.573a7.3,7.3,0,0,1,1.913-4.032,4.31,4.31,0,0,1,1-.713,1.726,1.726,0,0,1,.4-.15,6.112,6.112,0,0,0-1.292.971,7.362,7.362,0,0,0-1.747,3.97,24.769,24.769,0,0,0-.21,3.058,18.7,18.7,0,0,1-.356,3.552,16.89,16.89,0,0,1-1.508,3.643,4.977,4.977,0,0,0-.588,3.886c.481,1.288,1.7,2.2,2.157,3.594a2.889,2.889,0,0,1-.141,2.08,7.228,7.228,0,0,1-1.085,1.632,4.963,4.963,0,0,0-1.423,5.894,10.093,10.093,0,0,1,.5,2.517,4.318,4.318,0,0,1-.338,1.918,2.3,2.3,0,0,1-.776.955A1.249,1.249,0,0,1,561.823,144.488Z",
    transform: "translate(-561.821 -106.624)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M541.068,180.366l-6.83,19.69-28.484,1.527L501,212.152l29.737,3.009a11.236,11.236,0,0,0,14.869-6.594l7.936-22.152Z",
    transform: "translate(-492.898 -95.405)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2677",
    "data-name": "Group 2677",
    transform: "translate(54.155 140.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2675",
    "data-name": "Group 2675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2673",
    "data-name": "Group 2673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M614.793,383.747s-20.874-66.3-21.317-68.45c-.4-1.945,7.576-49.655,8.58-62l-28.2,1.052,0,.206-11.989.664L572.6,390.806h12.979l-1.286-44.985A438.1,438.1,0,0,0,603.762,389.2Z",
    transform: "translate(-561.86 -253.293)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2674",
    "data-name": "Group 2674",
    transform: "translate(17.941 80.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M590.589,387.675c.011-.412-.157-15.072-.157-15.072-.162.877-4.976-12.73-4.859-13.557C585.632,358.618,590.589,387.675,590.589,387.675Z",
    transform: "translate(-585.57 -359.042)",
    fill: "#a36957"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2676",
    "data-name": "Group 2676",
    transform: "translate(17.289 73.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M584.813,350.535a3.032,3.032,0,0,0-.083.822,21.687,21.687,0,0,0,.017,2.247c.018.476.067.994.129,1.55s.147,1.15.275,1.766a30.129,30.129,0,0,0,1.061,3.95c.942,2.743,1.982,5.142,2.72,6.883q.526,1.191.9,2.05a3.036,3.036,0,0,0,.385.73,3.1,3.1,0,0,0-.229-.793c-.174-.5-.439-1.218-.776-2.1-.667-1.77-1.661-4.187-2.6-6.905a34.283,34.283,0,0,1-1.08-3.892c-.137-.6-.225-1.189-.31-1.734s-.142-1.057-.18-1.526c-.089-.937-.129-1.7-.153-2.227A3.077,3.077,0,0,0,584.813,350.535Z",
    transform: "translate(-584.709 -350.535)",
    fill: "#a36957"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709",
    transform: "translate(55.714 276.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2708",
    "data-name": "Group 2708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2679",
    "data-name": "Group 2679",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2678",
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M572.856,435.332l-.005-1.219,13.295-.579.036,5.028-.82.055c-3.649.213-18.57.829-21.012.1C561.625,437.9,572.856,435.332,572.856,435.332Z",
    transform: "translate(-563.923 -433.534)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2681",
    "data-name": "Group 2681",
    transform: "translate(0 4.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2680",
    "data-name": "Group 2680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M586.366,439.774a1.149,1.149,0,0,1-.227.026l-.653.042-2.4.113c-2.03.08-4.837.154-7.937.168s-5.908-.036-7.939-.1l-2.4-.091-.653-.036a1.164,1.164,0,0,1-.228-.023,1.247,1.247,0,0,1,.229-.008l.655.006,2.4.04c2.031.033,4.837.064,7.936.051s5.9-.07,7.935-.121l2.4-.061.654-.012A1.263,1.263,0,0,1,586.366,439.774Z",
    transform: "translate(-563.921 -439.767)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2683",
    "data-name": "Group 2683",
    transform: "translate(3.35 3.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2682",
    "data-name": "Group 2682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M569.625,439.678a3.494,3.494,0,0,0-1.276-2.063,2.135,2.135,0,0,1,1.276,2.063Z",
    transform: "translate(-568.349 -437.611)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2685",
    "data-name": "Group 2685",
    transform: "translate(7.814 2.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2684",
    "data-name": "Group 2684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M574.957,437.353c-.038.023-.225-.2-.419-.506s-.321-.568-.284-.592.225.2.418.505S574.994,437.33,574.957,437.353Z",
    transform: "translate(-574.247 -436.254)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2687",
    "data-name": "Group 2687",
    transform: "translate(8.76 1.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2686",
    "data-name": "Group 2686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M576.33,436.714c-.03.033-.238-.105-.467-.309s-.39-.4-.361-.429.239.105.468.309S576.359,436.682,576.33,436.714Z",
    transform: "translate(-575.498 -435.971)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2689",
    "data-name": "Group 2689",
    transform: "translate(8.883 1.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2688",
    "data-name": "Group 2688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M577.042,435.277a1.543,1.543,0,0,1-.69.091,1.572,1.572,0,0,1-.692-.07,1.555,1.555,0,0,1,.689-.091A1.575,1.575,0,0,1,577.042,435.277Z",
    transform: "translate(-575.66 -435.207)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691",
    transform: "translate(8.929 0.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2690",
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M577.286,434.132a1.948,1.948,0,0,1-1.565.123,4.326,4.326,0,0,1,.783-.057A4.275,4.275,0,0,1,577.286,434.132Z",
    transform: "translate(-575.721 -434.119)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693",
    transform: "translate(5.575 0.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2692",
    "data-name": "Group 2692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M573.784,435.8a2.439,2.439,0,0,1-.85,0,4.985,4.985,0,0,1-.906-.2,2.488,2.488,0,0,1-.519-.212.457.457,0,0,1-.211-.263.334.334,0,0,1,.128-.341,1.558,1.558,0,0,1,1.929.449,1.512,1.512,0,0,1,.279.566.481.481,0,0,1,.023.23,2.413,2.413,0,0,0-.39-.724,1.531,1.531,0,0,0-.727-.469,1.322,1.322,0,0,0-1.013.073c-.135.1-.081.26.069.348a2.58,2.58,0,0,0,.479.2,5.878,5.878,0,0,0,.876.224C573.46,435.778,573.784,435.778,573.784,435.8Z",
    transform: "translate(-571.288 -434.621)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(7.743 0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M574.261,435.711a.84.84,0,0,1-.1-.589,1.385,1.385,0,0,1,.23-.622.851.851,0,0,1,.706-.436.338.338,0,0,1,.263.391.94.94,0,0,1-.143.381,2.558,2.558,0,0,1-.4.515,1.222,1.222,0,0,1-.485.346c-.015-.02.169-.153.4-.423a2.975,2.975,0,0,0,.354-.511c.116-.18.195-.5-.019-.541-.213-.02-.429.193-.558.362a1.415,1.415,0,0,0-.238.554A3.183,3.183,0,0,0,574.261,435.711Z",
    transform: "translate(-574.154 -434.063)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697",
    transform: "translate(17.474 1.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M591.7,434.967c0,.03-.379-.035-.976.038a4.142,4.142,0,0,0-3.455,2.774c-.2.568-.218.949-.247.945a.755.755,0,0,1,0-.266,3.465,3.465,0,0,1,.141-.714,4.018,4.018,0,0,1,3.551-2.851,3.475,3.475,0,0,1,.727.016A.747.747,0,0,1,591.7,434.967Z",
    transform: "translate(-587.014 -434.881)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699",
    transform: "translate(11.93 3.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2698",
    "data-name": "Group 2698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M583.553,438.379a10.866,10.866,0,0,1-3.866.021c0-.047.868.01,1.933,0S583.548,438.333,583.553,438.379Z",
    transform: "translate(-579.687 -438.362)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2701",
    "data-name": "Group 2701",
    transform: "translate(18.011 3.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2700",
    "data-name": "Group 2700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M588.1,438.345c.032.032-.07.183-.158.381s-.135.375-.18.372-.069-.209.034-.437S588.071,438.314,588.1,438.345Z",
    transform: "translate(-587.724 -438.34)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2703",
    "data-name": "Group 2703",
    transform: "translate(18.859 2.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2702",
    "data-name": "Group 2702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M589.345,436.733c.032.031-.053.17-.19.308s-.272.227-.3.2.054-.169.19-.308S589.313,436.7,589.345,436.733Z",
    transform: "translate(-588.845 -436.727)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2705",
    "data-name": "Group 2705",
    transform: "translate(20.001 1.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2704",
    "data-name": "Group 2704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M591.109,435.97c-.009.045-.185.044-.379.114s-.334.173-.369.143.075-.213.316-.3S591.121,435.929,591.109,435.97Z",
    transform: "translate(-590.354 -435.895)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2707",
    "data-name": "Group 2707",
    transform: "translate(21.351 1.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M592.537,435.633c.016.042-.06.11-.169.152s-.211.045-.228,0,.06-.11.169-.153S592.52,435.593,592.537,435.633Z",
    transform: "translate(-592.137 -435.604)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    transform: "translate(88.884 270.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2711",
    "data-name": "Group 2711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M614.67,432.082l-.5-1.109L626.057,425l2.093,4.572-.726.387c-3.242,1.69-16.6,8.363-19.129,8.7C605.476,439.022,614.67,432.082,614.67,432.082Z",
    transform: "translate(-607.758 -424.998)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2713",
    "data-name": "Group 2713",
    transform: "translate(0.001 4.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M628.195,430.573a1.327,1.327,0,0,1-.2.117l-.578.306-2.147,1.087c-1.819.9-4.349,2.122-7.172,3.405s-5.4,2.387-7.283,3.161l-2.231.9-.611.235a1.2,1.2,0,0,1-.217.072,1.16,1.16,0,0,1,.2-.1l.6-.263,2.211-.949c1.866-.8,4.439-1.922,7.26-3.2s5.357-2.481,7.188-3.36l2.169-1.041.592-.278A1.275,1.275,0,0,1,628.195,430.573Z",
    transform: "translate(-607.759 -430.572)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2715",
    "data-name": "Group 2715",
    transform: "translate(2.347 10.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2714",
    "data-name": "Group 2714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M612.87,440.292a3.5,3.5,0,0,0-2.01-1.36,2.137,2.137,0,0,1,2.01,1.36Z",
    transform: "translate(-610.86 -438.914)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2717",
    "data-name": "Group 2717",
    transform: "translate(6.001 7.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2716",
    "data-name": "Group 2716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M616.782,435.99c-.024.037-.288-.093-.589-.29s-.526-.387-.5-.424.288.093.589.291S616.806,435.953,616.782,435.99Z",
    transform: "translate(-615.689 -435.27)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719",
    transform: "translate(6.777 7.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2718",
    "data-name": "Group 2718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M617.773,434.843c-.014.042-.261,0-.553-.091s-.518-.2-.5-.244.261,0,.553.091S617.786,434.8,617.773,434.843Z",
    transform: "translate(-616.714 -434.492)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2721",
    "data-name": "Group 2721",
    transform: "translate(6.684 6.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2720",
    "data-name": "Group 2720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M617.844,433.081c.018.04-.247.2-.593.365a1.557,1.557,0,0,1-.66.22c-.019-.04.246-.2.592-.365A1.561,1.561,0,0,1,617.844,433.081Z",
    transform: "translate(-616.591 -433.072)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    transform: "translate(6.407 5.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2722",
    "data-name": "Group 2722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M617.6,431.9c.029.03-.214.307-.609.522a1.347,1.347,0,0,1-.768.232,4.174,4.174,0,0,1,.691-.373A4.319,4.319,0,0,1,617.6,431.9Z",
    transform: "translate(-616.226 -431.892)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(3.6 7.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M615.124,434.91a2.451,2.451,0,0,1-.776.346,4.948,4.948,0,0,1-.906.192,2.452,2.452,0,0,1-.56.02.461.461,0,0,1-.3-.154.333.333,0,0,1-.023-.362,1.558,1.558,0,0,1,1.943-.381,1.517,1.517,0,0,1,.487.4c.091.118.123.2.114.2a2.4,2.4,0,0,0-.651-.5,1.529,1.529,0,0,0-.857-.13,1.318,1.318,0,0,0-.894.481c-.082.147.032.269.205.289a2.546,2.546,0,0,0,.52-.011,5.783,5.783,0,0,0,.891-.154C614.818,435.018,615.114,434.885,615.124,434.91Z",
    transform: "translate(-612.515 -434.386)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    transform: "translate(5.627 5.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M615.593,434.654a.838.838,0,0,1-.333-.5,1.4,1.4,0,0,1-.045-.661.855.855,0,0,1,.466-.687c.19-.058.633.324.664.467.048.142-.224.069-.238.188a2.608,2.608,0,0,1-.154.634,1.213,1.213,0,0,1-.3.514c-.022-.013.091-.209.194-.55a2.96,2.96,0,0,0,.113-.612c.033-.211-.028-.538-.238-.486-.2.07-.313.352-.361.56a1.4,1.4,0,0,0,.009.6A3.138,3.138,0,0,0,615.593,434.654Z",
    transform: "translate(-615.195 -432.802)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    transform: "translate(15.659 1.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M631.49,426.363c.009.029-.36.124-.875.435a4.142,4.142,0,0,0-2.015,3.945c.05.6.19.955.161.964a.774.774,0,0,1-.11-.243,3.468,3.468,0,0,1-.163-.709,4.021,4.021,0,0,1,2.071-4.056,3.494,3.494,0,0,1,.67-.284A.787.787,0,0,1,631.49,426.363Z",
    transform: "translate(-628.453 -426.361)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(10.42 5.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M625.047,432.9a10.849,10.849,0,0,1-3.518,1.6c-.015-.044.8-.346,1.765-.789S625.023,432.861,625.047,432.9Z",
    transform: "translate(-621.529 -432.899)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733",
    transform: "translate(16.143 4.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M629.24,431.466c.042.016.011.2.013.412s.03.4-.013.413-.148-.162-.148-.412S629.2,431.448,629.24,431.466Z",
    transform: "translate(-629.092 -431.464)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735",
    transform: "translate(16.413 3.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M629.714,429.469c.042.015.021.176-.046.359s-.156.319-.2.3-.02-.176.047-.359S629.673,429.453,629.714,429.469Z",
    transform: "translate(-629.449 -429.467)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(17.128 2.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M630.988,428.031c.01.045-.151.116-.3.258s-.233.294-.277.281-.019-.225.168-.4S630.983,427.988,630.988,428.031Z",
    transform: "translate(-630.393 -428.009)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739",
    transform: "translate(18.212 1.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M632.135,427.176c.032.031-.01.124-.092.208s-.175.127-.206.1.009-.125.092-.209S632.1,427.145,632.135,427.176Z",
    transform: "translate(-631.826 -427.166)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(41.193 64.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754",
    transform: "translate(0.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -330.86, -72.23)",
    filter: "url(#Path_501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501-2",
    "data-name": "Path 501",
    d: "M596.106,206.591l-2.214-27.011,11.372.2s.527-3.982-1.149-12.719c-1.028-5.357-4.6-8.642-8.6-10.594V156.4l-.347-.091a32.5,32.5,0,0,0-10.416-2.718l-13.958.161s-10.663-1.33-16.565,6.271c-2.274,2.928-9.309,22.969-9.309,22.969l16.754,8.069-1.594-11.113s.316,8.057,1.345,10.61c.573,1.423,2.231,5.839,2.231,5.839l-.216,13.328Z",
    transform: "translate(-214.07 -81.36)",
    fill: "#ebebeb",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    transform: "translate(41.409 16.098)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -372.27, -88.33)",
    filter: "url(#Path_502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502-2",
    "data-name": "Path 502",
    d: "M601.721,180.836l-2.072,8.827h19.546l-1.286-14.8Z",
    transform: "translate(-227.38 -86.54)",
    fill: "#ebebeb",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(43.251 30.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M619.787,194.287a14.553,14.553,0,0,0-2.587-.257c-1.6-.094-3.818-.173-6.268-.162s-4.667.118-6.268.245a13.965,13.965,0,0,0-2.581.319,17.453,17.453,0,0,0,2.6-.014c1.6-.049,3.811-.107,6.253-.119s4.654.02,6.255.036A16.6,16.6,0,0,0,619.787,194.287Z",
    transform: "translate(-602.083 -193.868)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751",
    transform: "translate(42.568 16.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M601.251,174.768a11.726,11.726,0,0,0-.065,2.246c.015,1.385.065,3.3.147,5.408s.18,4.022.273,5.4a11.632,11.632,0,0,0,.239,2.233,11.548,11.548,0,0,0,.065-2.245c-.014-1.385-.064-3.3-.147-5.409s-.18-4.022-.272-5.4A11.6,11.6,0,0,0,601.251,174.768Z",
    transform: "translate(-601.181 -174.768)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(24.852 23.671)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M577.768,184.872s4.345,32.21,16.557,31.357c0,0,5.5-.065,7.266-3.72v-1.438Z",
    transform: "translate(-577.768 -184.872)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(40.447 17.924)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M600.522,177.277l-2.338,15.79,1.513,2.771,2.492-5.418-1.054-.025Z",
    transform: "translate(-598.184 -177.277)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757",
    transform: "translate(14.973 22.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M568.429,203.6a3.3,3.3,0,0,1-.33-.754c-.19-.493-.442-1.216-.734-2.114a64.261,64.261,0,0,1-1.87-7.148,51.668,51.668,0,0,1-.926-7.333c-.045-.945-.059-1.71-.045-2.239a3.306,3.306,0,0,1,.057-.822c.063,0,.105,1.166.267,3.042a68.174,68.174,0,0,0,1.034,7.275c.561,2.816,1.236,5.33,1.749,7.143q.36,1.261.613,2.147A3.335,3.335,0,0,1,568.429,203.6Z",
    transform: "translate(-564.518 -183.188)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    transform: "translate(22.813 48.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M575.888,221.358c-.1.032-.406-.664-.675-1.552a3.743,3.743,0,0,1-.3-1.666c.1-.032.406.663.675,1.552A3.754,3.754,0,0,1,575.888,221.358Z",
    transform: "translate(-574.879 -218.139)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(25.062 47.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M578.3,220.712a6.977,6.977,0,0,1-.07-4.722,15.874,15.874,0,0,1,.017,2.362A15.9,15.9,0,0,1,578.3,220.712Z",
    transform: "translate(-577.851 -215.99)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763",
    transform: "translate(0 29.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M561.972,200.825c-.049.1-3.948-1.752-8.708-4.131s-8.581-4.387-8.533-4.484,3.947,1.752,8.709,4.131S562.02,200.728,561.972,200.825Z",
    transform: "translate(-544.73 -192.206)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2813",
    "data-name": "Group 2813",
    transform: "translate(59.472 25.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795",
    transform: "translate(0 5.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2793",
    "data-name": "Group 2793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2792",
    "data-name": "Group 2792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2791",
    "data-name": "Group 2791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M574.72,145.36c.087-3.828.108-7.86.108-7.86s-4.91-.946-5.765-7.406c-.816-6.161,1.466-20.617,1.466-20.617h0c7.173-2.711,14.625-.253,19.54,5.558h0l-1.22,31.08a6.672,6.672,0,0,1-7.219,6.179h0A7.048,7.048,0,0,1,574.72,145.36Z",
    transform: "translate(-568.887 -108.375)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2775",
    "data-name": "Group 2775",
    transform: "translate(0.95 10.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    transform: "translate(0.318 1.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M570.565,124.867a.826.826,0,0,0,.774.853.789.789,0,0,0,.869-.722.826.826,0,0,0-.773-.854A.79.79,0,0,0,570.565,124.867Z",
    transform: "translate(-570.563 -124.141)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2774",
    "data-name": "Group 2774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2773",
    "data-name": "Group 2773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M570.155,123.4c.1.11.736-.336,1.625-.311s1.527.487,1.626.38c.048-.047-.051-.244-.329-.458a2.268,2.268,0,0,0-1.3-.437,2.18,2.18,0,0,0-1.3.382C570.2,123.16,570.106,123.352,570.155,123.4Z",
    transform: "translate(-570.143 -122.574)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(10.206 11.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2778",
    "data-name": "Group 2778",
    transform: "translate(0.071 1.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M582.471,125.608a.825.825,0,0,0,.774.853.788.788,0,0,0,.869-.722.826.826,0,0,0-.773-.854A.79.79,0,0,0,582.471,125.608Z",
    transform: "translate(-582.469 -124.882)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2779",
    "data-name": "Group 2779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M582.387,124.143c.1.11.738-.336,1.625-.31s1.528.486,1.627.38c.048-.047-.05-.244-.33-.458a2.258,2.258,0,0,0-1.3-.437,2.169,2.169,0,0,0-1.3.382C582.436,123.9,582.339,124.094,582.387,124.143Z",
    transform: "translate(-582.375 -123.317)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2787",
    "data-name": "Group 2787",
    transform: "translate(4.581 11.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2786",
    "data-name": "Group 2786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2785",
    "data-name": "Group 2785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2784",
    "data-name": "Group 2784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M577.186,130.626a5.838,5.838,0,0,0-1.435-.3c-.226-.03-.44-.08-.474-.236a1.157,1.157,0,0,1,.169-.668q.342-.815.715-1.709a29.611,29.611,0,0,0,1.622-4.477,29.69,29.69,0,0,0-1.979,4.336q-.36.9-.687,1.721a1.312,1.312,0,0,0-.141.886.569.569,0,0,0,.364.341,1.543,1.543,0,0,0,.384.064A5.8,5.8,0,0,0,577.186,130.626Z",
    transform: "translate(-574.94 -123.238)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2790",
    "data-name": "Group 2790",
    transform: "translate(5.942 27.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2789",
    "data-name": "Group 2789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2788",
    "data-name": "Group 2788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M576.739,146.2a16.371,16.371,0,0,0,8.676-2.076s-2.2,4.365-8.628,3.6Z",
    transform: "translate(-576.739 -144.123)",
    fill: "#a36957"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797",
    transform: "translate(9.947 13.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M585.146,120.641c-.182.278-.857.154-1.614.018-.754-.151-1.427-.286-1.494-.611s.707-.744,1.716-.549S585.33,120.378,585.146,120.641Z",
    transform: "translate(-582.032 -119.45)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2799",
    "data-name": "Group 2799",
    transform: "translate(0.934 12.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2798",
    "data-name": "Group 2798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M573.419,119.077c-.069.323-.791.441-1.625.484s-1.566-.017-1.664-.334.606-.8,1.609-.847S573.49,118.763,573.419,119.077Z",
    transform: "translate(-570.121 -118.376)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2800",
    "data-name": "Group 2800",
    transform: "translate(6.29 25.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M577.75,135.8a.449.449,0,0,0-.491.225.5.5,0,1,0,.3-.241",
    transform: "translate(-577.2 -135.765)",
    fill: "#a36957"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2802",
    "data-name": "Group 2802",
    transform: "translate(6.006 25.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2801",
    "data-name": "Group 2801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M577.867,135.865c.04-.036-.142-.253-.53-.169a.673.673,0,0,0-.486.475.761.761,0,0,0,.267.8.747.747,0,0,0,.851.005.639.639,0,0,0,.273-.631c-.078-.4-.373-.462-.381-.407-.033.051.1.188.076.424a.335.335,0,0,1-.18.278.384.384,0,0,1-.384-.017.4.4,0,0,1-.136-.366.383.383,0,0,1,.2-.28C577.652,135.864,577.839,135.92,577.867,135.865Z",
    transform: "translate(-576.825 -135.677)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2812",
    "data-name": "Group 2812",
    transform: "translate(1.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803",
    "data-name": "Group 2803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M587.5,121.01c-.766,1.774-2.633,3.14-2.374,5.055.167,1.236.96,2.388.806,3.626-.194,1.554-1.808,2.632-2.037,4.181-.28,1.9,1.569,3.378,2.307,5.151,1.075,2.583-.3,5.487-.333,8.285a8.883,8.883,0,0,0,7.865,8.64c1.728.142,3.674-.379,4.569-1.863.739-1.225.592-2.78,1.034-4.14.661-2.025,2.59-3.507,3-5.6.742-3.811-3.864-6.965-3.561-10.836.129-1.653,1.15-3.1,1.584-4.7a6.883,6.883,0,0,0-1.351-6.123c-1.137-1.352-2.786-2.241-3.754-3.718-1.1-1.675-1.136-3.8-1.55-5.759a14.508,14.508,0,0,0-23.042-8.5s-1.1,4.987,4.019,5.821,7.492-.129,8.069,1.923a5.425,5.425,0,0,0,1.533,4.686C586.4,119.435,588.389,118.956,587.5,121.01Z",
    transform: "translate(-570.563 -101.736)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2805",
    "data-name": "Group 2805",
    transform: "translate(16.588 13.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2804",
    "data-name": "Group 2804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M601.006,160.084a2.1,2.1,0,0,1-.468-.048,6.917,6.917,0,0,1-1.3-.352,9.184,9.184,0,0,1-3.96-2.932,10.374,10.374,0,0,1-1.684-3,12.034,12.034,0,0,1-.688-3.885,15.823,15.823,0,0,1,.545-4.321,18.861,18.861,0,0,1,.724-2.189,21.81,21.81,0,0,0,.831-2.174,4.087,4.087,0,0,0-.008-2.219,12.074,12.074,0,0,0-.86-2.072,13.825,13.825,0,0,1-.881-2.051,4.431,4.431,0,0,1-.159-2.175,15.387,15.387,0,0,1,1.678-3.562,6.778,6.778,0,0,0,.685-3.223,7.617,7.617,0,0,0-1.687-4.464,13.487,13.487,0,0,0-1.286-1.252,5.23,5.23,0,0,1,1.4,1.152,7.589,7.589,0,0,1,1.849,4.551,7,7,0,0,1-.67,3.378,15.673,15.673,0,0,0-1.616,3.489,6.377,6.377,0,0,0,1.03,3.985,12.3,12.3,0,0,1,.893,2.14,4.486,4.486,0,0,1,.01,2.424,21.738,21.738,0,0,1-.847,2.217,18.619,18.619,0,0,0-.716,2.143,15.657,15.657,0,0,0-.555,4.216,10.918,10.918,0,0,0,2.228,6.715,9.335,9.335,0,0,0,3.8,2.962C600.363,159.975,601.015,160.04,601.006,160.084Z",
    transform: "translate(-592.485 -120.169)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2807",
    "data-name": "Group 2807",
    transform: "translate(1.83 2.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2806",
    "data-name": "Group 2806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M595.507,118.15a5.364,5.364,0,0,1-1.127.168,11.752,11.752,0,0,1-3.117-.082,5.925,5.925,0,0,1-3.932-2.387,12.806,12.806,0,0,1-1.032-2.54,4.2,4.2,0,0,0-1.724-2.127,12.275,12.275,0,0,0-5.307-1.385,9.217,9.217,0,0,1-4.411-1.373,4.372,4.372,0,0,1-1.805-2.527,2.722,2.722,0,0,1-.058-.853.87.87,0,0,1,.061-.292,5.558,5.558,0,0,0,.146,1.108,4.356,4.356,0,0,0,1.816,2.336,9.189,9.189,0,0,0,4.293,1.241,12.291,12.291,0,0,1,5.478,1.416,4.554,4.554,0,0,1,1.87,2.318,13.086,13.086,0,0,0,.978,2.483,5.715,5.715,0,0,0,3.68,2.309,13.24,13.24,0,0,0,3.055.2A7.673,7.673,0,0,1,595.507,118.15Z",
    transform: "translate(-572.981 -104.752)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    transform: "translate(3.218 1.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2808",
    "data-name": "Group 2808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M594.075,111.672a2.3,2.3,0,0,1-.887.131,5.425,5.425,0,0,1-3.795-1.516,7.191,7.191,0,0,1-1.174-1.566c-.683-1.151-1.339-2.57-2.754-3.157a9.051,9.051,0,0,0-4.239-.373,12.958,12.958,0,0,1-3.618-.03,4.507,4.507,0,0,1-2.233-1,2.569,2.569,0,0,1-.445-.5c-.086-.127-.123-.2-.113-.205.032-.024.212.244.655.586a4.647,4.647,0,0,0,2.182.845,13.634,13.634,0,0,0,3.54-.057,9.114,9.114,0,0,1,4.43.374,4.375,4.375,0,0,1,1.806,1.5,20.007,20.007,0,0,1,1.1,1.834,7.1,7.1,0,0,0,1.09,1.517,5.209,5.209,0,0,0,1.3.961,5.612,5.612,0,0,0,2.267.633C593.755,111.682,594.07,111.638,594.075,111.672Z",
    transform: "translate(-574.816 -103.454)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811",
    transform: "translate(22.025 16.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2810",
    "data-name": "Group 2810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M605.012,159.133c-.039-.017.2-.5.482-1.435a13.027,13.027,0,0,0,.5-4.056,12.46,12.46,0,0,0-1.613-5.778c-.553-.991-1.395-1.874-2.079-2.962a5.356,5.356,0,0,1-.763-1.827,4.13,4.13,0,0,1,.168-2.042,23.885,23.885,0,0,0,1.348-3.608,4.973,4.973,0,0,0-.981-3.28,15.092,15.092,0,0,1-.81-1.5,5.41,5.41,0,0,1-.428-1.58,14.006,14.006,0,0,1,.086-2.885,7.633,7.633,0,0,0-.359-4.021,3.646,3.646,0,0,0-.893-1.184c0-.006.035.008.092.043a1.527,1.527,0,0,1,.241.173,2.8,2.8,0,0,1,.7.9,7.5,7.5,0,0,1,.5,4.112,14.206,14.206,0,0,0-.039,2.822,7.166,7.166,0,0,0,1.227,2.939,9.986,9.986,0,0,1,.823,1.609,3.814,3.814,0,0,1,.228,1.91,22.628,22.628,0,0,1-1.354,3.674,3.753,3.753,0,0,0-.157,1.852,5,5,0,0,0,.7,1.694c.649,1.046,1.494,1.946,2.066,2.984a12.494,12.494,0,0,1,1.578,5.953,12.237,12.237,0,0,1-.636,4.109,8.943,8.943,0,0,1-.436,1.045A1.487,1.487,0,0,1,605.012,159.133Z",
    transform: "translate(-599.67 -122.968)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2823",
    "data-name": "Group 2823",
    transform: "translate(51.766 115.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2814",
    "data-name": "Group 2814",
    transform: "translate(0.122 0.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M564.261,323.966s-5.1-48.308-5.388-66.158,8.025-35.462,8.025-35.462l32.6-1.379s6.444,18.112,6.559,25.719c.225,14.784-3.928,29.384-3.45,41.112l1.09,36.168",
    transform: "translate(-558.865 -220.967)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2816",
    "data-name": "Group 2816",
    transform: "translate(4.448 43.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2815",
    "data-name": "Group 2815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M606.179,278.6a4.369,4.369,0,0,1-.532.4l-.3.21c-.1.086-.2.2-.316.3a4.856,4.856,0,0,0-.726.813c-1.053,1.289-1.821,3.593-2.551,6.466a21.735,21.735,0,0,1-1.65,4.6,8.283,8.283,0,0,1-.724,1.144c-.141.182-.269.376-.425.55l-.5.5A8.1,8.1,0,0,1,596,295.164c-1.825.8-3.885,1.18-5.767,2.123a9.11,9.11,0,0,0-4.184,4.769c-.918,2.051-1.475,4.2-2.24,6.212a11.259,11.259,0,0,1-3.4,5.161,9.343,9.343,0,0,1-5.335,1.672c-1.755.1-3.381.051-4.838.272a7.645,7.645,0,0,0-3.649,1.377,5.081,5.081,0,0,0-1.7,2.387,3.583,3.583,0,0,0-.126,1.855c.084.425.2.629.177.639a1.942,1.942,0,0,1-.254-.621,3.521,3.521,0,0,1,.057-1.919,5.185,5.185,0,0,1,1.7-2.514,7.8,7.8,0,0,1,3.746-1.48c1.485-.242,3.128-.207,4.858-.323a9.054,9.054,0,0,0,5.136-1.634,10.955,10.955,0,0,0,3.263-5.01c.752-1.986,1.305-4.142,2.242-6.237a9.477,9.477,0,0,1,4.368-4.952c1.958-.972,4.018-1.339,5.8-2.112a7.8,7.8,0,0,0,2.361-1.494l.481-.474c.151-.166.275-.353.412-.525a7.986,7.986,0,0,0,.707-1.1,21.837,21.837,0,0,0,1.669-4.515c.763-2.858,1.584-5.2,2.7-6.486a4.817,4.817,0,0,1,.768-.8c.12-.107.226-.213.334-.3l.313-.2A4.216,4.216,0,0,1,606.179,278.6Z",
    transform: "translate(-564.582 -278.602)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2818",
    "data-name": "Group 2818",
    transform: "translate(1.335 21.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2817",
    "data-name": "Group 2817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M605.379,249.059a3.911,3.911,0,0,1,.042.647,8.032,8.032,0,0,1-.226,1.849,11.956,11.956,0,0,1-3.683,5.694,21.882,21.882,0,0,1-3.818,2.788c-1.46.867-3.072,1.693-4.723,2.625a24.7,24.7,0,0,0-4.831,3.4,18.662,18.662,0,0,0-3.66,5.144,47.471,47.471,0,0,1-3.173,5.591,13.359,13.359,0,0,1-2.07,2.288,13.049,13.049,0,0,1-2.461,1.639,30.479,30.479,0,0,1-5.065,1.942c-1.618.5-3.127.944-4.445,1.5a17.339,17.339,0,0,0-3.391,1.816,10.543,10.543,0,0,0-2.129,1.963,10.157,10.157,0,0,0-1.277,2.122,3.974,3.974,0,0,1,.21-.614,7.493,7.493,0,0,1,.946-1.6,10.35,10.35,0,0,1,2.121-2.047,17.167,17.167,0,0,1,3.411-1.895c1.33-.576,2.847-1.037,4.455-1.55a30.622,30.622,0,0,0,4.995-1.951,12.762,12.762,0,0,0,2.384-1.6,13.027,13.027,0,0,0,2-2.228,47.933,47.933,0,0,0,3.14-5.551,18.948,18.948,0,0,1,3.742-5.239,24.8,24.8,0,0,1,4.919-3.433c1.665-.929,3.279-1.742,4.736-2.59a21.971,21.971,0,0,0,3.8-2.713,12.054,12.054,0,0,0,3.722-5.527A11.689,11.689,0,0,0,605.379,249.059Z",
    transform: "translate(-560.467 -249.059)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2820",
    "data-name": "Group 2820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2819",
    "data-name": "Group 2819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M559,260.3a.489.489,0,0,1-.066-.147,3.246,3.246,0,0,1-.071-2.265,7.417,7.417,0,0,1,4.792-4.418c1.342-.461,2.865-.739,4.451-1.155a8.337,8.337,0,0,0,6.167-4.588,23.3,23.3,0,0,0,1.13-2.719,29.6,29.6,0,0,1,2.4-5.8,9.266,9.266,0,0,1,4.937-3.838,45.163,45.163,0,0,1,5.664-1.435,18.757,18.757,0,0,0,4.924-1.677,10.312,10.312,0,0,0,3.333-3,11.257,11.257,0,0,0,2.118-6.129,17.542,17.542,0,0,0-.161-2.418,7.987,7.987,0,0,1,.314,2.421,11.177,11.177,0,0,1-2.044,6.288,10.519,10.519,0,0,1-3.4,3.126,18.9,18.9,0,0,1-5,1.746,45.962,45.962,0,0,0-5.611,1.443,8.9,8.9,0,0,0-4.736,3.686,29.667,29.667,0,0,0-2.37,5.722,23.405,23.405,0,0,1-1.159,2.763,8.654,8.654,0,0,1-6.419,4.732c-1.609.406-3.123.667-4.446,1.1a7.332,7.332,0,0,0-4.733,4.2,3.7,3.7,0,0,0-.144,1.753C558.948,260.09,559.015,260.3,559,260.3Z",
    transform: "translate(-558.703 -220.711)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    transform: "translate(5.488 80.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M603.911,327.019a2.155,2.155,0,0,1,.052.474,5.046,5.046,0,0,1-.139,1.367,7.768,7.768,0,0,1-2.86,4.088,12.752,12.752,0,0,1-3,1.782,39.687,39.687,0,0,1-3.768,1.3,31.124,31.124,0,0,0-4.092,1.494,11.819,11.819,0,0,0-3.724,2.716c-1.1,1.156-2.057,2.419-3.114,3.534a14.249,14.249,0,0,1-3.487,2.729,15.323,15.323,0,0,1-7.2,1.871,14.268,14.268,0,0,1-4.953-.823,9.07,9.07,0,0,1-1.257-.539,2.17,2.17,0,0,1-.416-.231,2.191,2.191,0,0,1,.45.159,12.156,12.156,0,0,0,1.273.465,14.936,14.936,0,0,0,4.9.689,15.283,15.283,0,0,0,7.024-1.909,14.023,14.023,0,0,0,3.383-2.677c1.035-1.1,1.983-2.362,3.109-3.542a12.136,12.136,0,0,1,3.844-2.793,30.628,30.628,0,0,1,4.151-1.492c1.338-.407,2.609-.785,3.747-1.257a12.7,12.7,0,0,0,2.955-1.7,7.808,7.808,0,0,0,2.884-3.908A8.946,8.946,0,0,0,603.911,327.019Z",
    transform: "translate(-565.957 -327.019)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2826",
    "data-name": "Group 2826",
    transform: "translate(59.028 57.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M600.765,182.261l-6.3.149a10.31,10.31,0,0,1-1.426,3.576,108.826,108.826,0,0,1-10.372-26.335c.148-.493.322-1.037.541-1.645a6.985,6.985,0,0,0-.083-2.771c-.176-1.1-.484-2.573-.576-3.256-.281-2.082-.616-2.409-1.342-2.173-.988.32.406,5.847-.4,5.966-.435.064-.967-1.829-1.121-3.382s-.857-6.332-1.37-6.65c-.753-.467-1.409.272-1.218,1.818.192,1.566.435,6.235-.386,6.3s-1.488-7.86-1.488-7.86.128-1.724-.823-1.683c-1.715.075-.375,8.427-.228,9.218.1.551-.788.651-.866.054-.081-.615-.495-7.923-2.24-7.864-1.34.045,1.037,6.883.285,8.468s-1.275-5.383-2.554-5.287c-.476.036-.828.129.047,4.072a88.97,88.97,0,0,0,3.058,9.243c2.027,10.933,10.924,45.912,24.873,39.509,7.8-3.583,10.971-19.462,10.971-19.462Z",
    transform: "translate(-568.301 -144.249)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2825",
    "data-name": "Group 2825",
    transform: "translate(5.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2824",
    "data-name": "Group 2824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M575.556,154.047a.429.429,0,0,0,.182-.025.4.4,0,0,0,.285-.437c-.018-.47-.092-1.154-.2-2.038a29.414,29.414,0,0,1-.348-3.224c-.01-.633.006-1.314.042-2.036a7.1,7.1,0,0,1,.11-1.09c.059-.343.288-.735.553-.688l.03.005h.013c.269-.012.48.2.566.518a2.979,2.979,0,0,1,.1,1.012v.024a61.308,61.308,0,0,0,.809,6.318c.061.282.124.567.212.854a4.109,4.109,0,0,0,.157.434,1.351,1.351,0,0,0,.129.225.412.412,0,0,0,.316.2.566.566,0,0,0,.476-.4,2.283,2.283,0,0,0,.141-.465,6.994,6.994,0,0,0,.122-.923,27.6,27.6,0,0,0-.051-3.785,8.75,8.75,0,0,1-.079-1.9,1.051,1.051,0,0,1,.372-.706.409.409,0,0,1,.325-.042.772.772,0,0,1,.18.078.247.247,0,0,1,.083.112,9.453,9.453,0,0,1,.525,1.9c.134.67.25,1.352.357,2.042s.2,1.388.287,2.092a14.508,14.508,0,0,0,.349,2.152,7.146,7.146,0,0,0,.341,1.069,1.911,1.911,0,0,0,.312.535.449.449,0,0,0,.453.165.484.484,0,0,0,.309-.34,3.718,3.718,0,0,0,.079-1.177c-.016-.375-.047-.746-.079-1.118-.054-.637-.115-1.267-.136-1.889a6.338,6.338,0,0,1,.023-.91,1.45,1.45,0,0,1,.092-.395.355.355,0,0,1,.073-.113c.012-.012.02-.007.029-.019l.1-.028c.5-.207.669.491.8,1.054.117.586.19,1.193.308,1.79.2,1.192.454,2.376.587,3.515a4.065,4.065,0,0,1-.067,1.628l-.531,1.623-.016.048.011.051a87.528,87.528,0,0,0,3.385,10.941c1.2,3.229,2.4,6.019,3.453,8.3s2,4.044,2.653,5.244l.787,1.353a3.233,3.233,0,0,0,.292.455,3.151,3.151,0,0,0-.232-.488c-.18-.342-.422-.8-.729-1.382-.614-1.218-1.523-2.992-2.542-5.285s-2.188-5.086-3.359-8.315a89.947,89.947,0,0,1-3.31-10.9l0,.1.53-1.6a4.4,4.4,0,0,0,.093-1.811c-.135-1.183-.383-2.333-.58-3.531-.117-.592-.188-1.2-.31-1.82a3.6,3.6,0,0,0-.309-.937.914.914,0,0,0-.418-.421.933.933,0,0,0-.6-.024l-.127.036a.648.648,0,0,0-.172.1.732.732,0,0,0-.191.269,1.859,1.859,0,0,0-.126.517,6.729,6.729,0,0,0-.026.976c.022.642.083,1.277.138,1.912.031.369.062.736.078,1.1a3.564,3.564,0,0,1-.056,1.017c-.019.079-.057.064-.014.1l0,0c0-.025.006.039,0,.028v-.008a.047.047,0,0,1,0-.026c0-.007.02-.033.011-.036a.113.113,0,0,1-.045-.042,1.624,1.624,0,0,1-.232-.41,6.966,6.966,0,0,1-.321-1,14.28,14.28,0,0,1-.341-2.1c-.085-.712-.184-1.413-.293-2.108s-.227-1.381-.365-2.06a9.389,9.389,0,0,0-.575-2.021.68.68,0,0,0-.237-.266,1.174,1.174,0,0,0-.282-.119.824.824,0,0,0-.639.089,1.416,1.416,0,0,0-.559.985,3.585,3.585,0,0,0-.013,1.037c.038.323.069.64.095.959a27.456,27.456,0,0,1,.068,3.727,6.737,6.737,0,0,1-.11.874,1.952,1.952,0,0,1-.115.392.488.488,0,0,1-.083.141c-.027.063-.051-.014-.049.088.039-.077,0-.034-.028-.1a1.071,1.071,0,0,1-.09-.157,3.791,3.791,0,0,1-.143-.387c-.084-.269-.148-.547-.21-.823a62.865,62.865,0,0,1-.855-6.269v.024a3.243,3.243,0,0,0-.123-1.125,1.146,1.146,0,0,0-.3-.5.786.786,0,0,0-.561-.2l.042,0a.653.653,0,0,0-.652.313,1.623,1.623,0,0,0-.232.588,7.039,7.039,0,0,0-.1,1.137c-.027.728-.033,1.413-.012,2.053a26.986,26.986,0,0,0,.418,3.239c.132.879.23,1.562.272,2.022a.357.357,0,0,1-.221.4C575.616,154.031,575.554,154.038,575.556,154.047Z",
    transform: "translate(-575.241 -144.228)",
    fill: "#a36957"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M505.607,208.23a16.254,16.254,0,0,0-4.383.5c-3.907,1.028-10.653,5.116-10.932,10.167h4.9s-2.744,5.841-1.937,5.3a63.044,63.044,0,0,0,6.256-5.635Z",
    transform: "translate(-490.291 -102.183)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2833",
    "data-name": "Group 2833",
    transform: "translate(80.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2828",
    "data-name": "Group 2828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2827",
    "data-name": "Group 2827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M598.338,86.214c-.108.009-.553-4.041-.994-9.048s-.709-9.073-.6-9.082.552,4.041.993,9.048S598.446,86.2,598.338,86.214Z",
    transform: "translate(-596.72 -68.084)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2830",
    "data-name": "Group 2830",
    transform: "translate(8.003 0.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2829",
    "data-name": "Group 2829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M622.406,68.411c.089.063-3.221,4.868-7.393,10.73s-7.626,10.565-7.715,10.5,3.221-4.866,7.394-10.73S622.318,68.348,622.406,68.411Z",
    transform: "translate(-607.297 -68.41)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2832",
    "data-name": "Group 2832",
    transform: "translate(14.708 22.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2831",
    "data-name": "Group 2831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M633.493,97.186c.022.106-3.841.99-8.628,1.974s-8.686,1.695-8.708,1.588,3.841-.99,8.628-1.974S633.471,97.079,633.493,97.186Z",
    transform: "translate(-616.158 -97.175)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Folder",
    transform: "translate(458.962 431.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2839",
    "data-name": "Group 2839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2835",
    "data-name": "Group 2835",
    transform: "translate(65.371 25.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M289.227,231.557,262.471,369.12l-3.5,18.008,178.623-.881c8.016-.039,15.121-7.157,17.7-17.733l31.674-129.873c1.958-8.028-2.338-16.377-8.423-16.371l-180.787.19C293.762,222.464,290.272,226.189,289.227,231.557Z",
    transform: "translate(-258.968 -222.27)",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2836",
    "data-name": "Group 2836",
    transform: "translate(65.371 25.753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -114.48, -124.2)",
    filter: "url(#Path_539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539-2",
    "data-name": "Path 539",
    d: "M289.227,231.557,262.471,369.12l-3.5,18.008,178.623-.881c8.016-.039,15.121-7.157,17.7-17.733l31.674-129.873c1.958-8.028-2.338-16.377-8.423-16.371l-180.787.19C293.762,222.464,290.272,226.189,289.227,231.557Z",
    transform: "translate(-144.49 -98.07)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2837",
    "data-name": "Group 2837"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -49.11, -98.45)",
    filter: "url(#Path_540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540-2",
    "data-name": "Path 540",
    d: "M399.435,351.519l-18.912-152.4c-.775-6.244-5.749-10.9-11.622-10.883l-41.471.135A11.3,11.3,0,0,0,319.238,192l-19.692,20.933-115.337.6c-7.048.036-12.463,6.706-11.529,14.2l17.559,140.857c.778,6.235,5.742,10.887,11.607,10.876l201.009-.4c22.388.464,24.525-6.148,24.525-6.148C401.723,378.611,399.438,351.536,399.435,351.519Z",
    transform: "translate(-123.47 -89.79)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2838",
    "data-name": "Group 2838",
    transform: "translate(81.195 84.198)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M338.872,348.612l-6.779,7.281-52.213-46.97,6.779-7.281Z",
    transform: "translate(-279.88 -300.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M329.936,299.509l7.492,6.74-47.243,50.74-7.492-6.74Z",
    transform: "translate(-280.565 -299.509)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(690.179 332.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2848",
    "data-name": "Group 2848",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2844",
    "data-name": "Group 2844",
    transform: "translate(18.129 13.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2841",
    "data-name": "Group 2841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2840",
    "data-name": "Group 2840"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -298.46, -13.9)",
    filter: "url(#Path_543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543-2",
    "data-name": "Path 543",
    d: "M508.321,97.147a1.412,1.412,0,0,1-.855-1.238l-.3-7.025a1.412,1.412,0,0,1,1.735-1.435,4.388,4.388,0,0,0,3.416-.675,3.952,3.952,0,0,0,1.766-2.587,4.045,4.045,0,0,0-.849-3.039,4.506,4.506,0,0,0-2.982-1.795,5.29,5.29,0,0,0-5.371,3.811,1.412,1.412,0,1,1-2.725-.74,8.134,8.134,0,0,1,8.42-5.877,7.284,7.284,0,0,1,4.911,2.9,6.873,6.873,0,0,1,1.384,5.2,6.78,6.78,0,0,1-2.986,4.481,7.394,7.394,0,0,1-3.83,1.25l.235,5.415a1.413,1.413,0,0,1-1.967,1.359Z",
    transform: "translate(-203.65 -62.6)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2843",
    "data-name": "Group 2843",
    transform: "translate(5.98 22.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2842",
    "data-name": "Group 2842"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -304.44, -36.34)",
    filter: "url(#Path_544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544-2",
    "data-name": "Path 544",
    d: "M512.313,107.231a1.155,1.155,0,1,1-1.231-1.073A1.155,1.155,0,0,1,512.313,107.231Z",
    transform: "translate(-205.57 -69.82)",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2847",
    "data-name": "Group 2847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M478.176,82.771a2.907,2.907,0,0,0,.069-.461c.036-.329.085-.777.148-1.353a15.928,15.928,0,0,1,.365-2.175c.1-.424.151-.9.306-1.372s.3-.989.47-1.528a26.015,26.015,0,0,1,3.763-7.209A25.374,25.374,0,0,1,506.754,58.8c.58.055,1.152.21,1.735.312a11.9,11.9,0,0,1,1.741.42A24.037,24.037,0,0,1,517,62.6a25.312,25.312,0,0,1,10,12.56,24.71,24.71,0,0,1,1.484,8.632,24.266,24.266,0,0,1-1.583,8.885l-.341.864-.045.114.046.107c1.9,4.371,3.759,8.658,5.563,12.813l.318-.362-11.332-4.354-.14-.054-.11.106a25.336,25.336,0,0,1-10.7,6.178,25.167,25.167,0,0,1-20.43-3.171,25.926,25.926,0,0,1-6.38-5.941,25.094,25.094,0,0,1-4.84-11.6q-.135-1.108-.238-1.968-.022-.849-.038-1.446c-.012-.372-.022-.664-.029-.886a1.544,1.544,0,0,0-.025-.3,1.683,1.683,0,0,0-.018.3c0,.222-.007.515-.011.888q0,.6,0,1.454.087.867.2,1.985a24.964,24.964,0,0,0,4.763,11.775,26.12,26.12,0,0,0,6.426,6.068,25.483,25.483,0,0,0,20.74,3.311,25.751,25.751,0,0,0,10.917-6.266l-.25.052,11.326,4.372.57.22-.252-.582-5.555-12.816v.221l.35-.883a24.78,24.78,0,0,0,1.616-9.083,25.235,25.235,0,0,0-1.525-8.821,25.767,25.767,0,0,0-10.223-12.794,24.457,24.457,0,0,0-6.9-3.1,12.3,12.3,0,0,0-1.772-.421c-.594-.1-1.176-.257-1.765-.311a24.927,24.927,0,0,0-15.737,3.077,25.456,25.456,0,0,0-8,7.074,25.9,25.9,0,0,0-3.726,7.325q-.238.819-.45,1.548c-.149.482-.194.959-.286,1.387a14.979,14.979,0,0,0-.319,2.2c-.042.579-.074,1.031-.1,1.362A3.238,3.238,0,0,0,478.176,82.771Z",
    transform: "translate(-478.144 -58.132)",
    fill: "#263238"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReports);
export default __webpack_public_path__ + "static/media/No_Reports.279e70a11c92c9558955d04c6de890d6.svg";
export { ForwardRef as ReactComponent };